import { Components } from "@mui/material/styles"

const Paper = (): Components => {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "initial",
        },
        rounded: {
          borderRadius: "0.5rem",
        },
      },
    },
  }
}

export default Paper
